import { createContext, useContext, useState, type ReactNode } from "react";

interface DetailPageShareContextValue {
  showShareDialog: boolean;
  setShowShareDialog: (show: boolean) => void;
}

const DetailPageShareContext = createContext<DetailPageShareContextValue | undefined>(undefined);

export function DetailPageShareProvider({ children }: { children: ReactNode }) {
  const [showShareDialog, setShowShareDialog] = useState(false);

  return (
    <DetailPageShareContext.Provider
      value={{
        showShareDialog,
        setShowShareDialog,
      }}
    >
      {children}
    </DetailPageShareContext.Provider>
  );
}

export function useDetailPageShare() {
  const context = useContext(DetailPageShareContext);
  if (!context) {
    return {
      showShareDialog: false,
      setShowShareDialog: () => {},
    };
  }
  return context;
}

